import ProductTitleInfo from './ProductTitleInfo';

export default ProductTitleInfo;
